<template>
  <div class="bg-white shadow-md flex flex-col flex-1" v-if="pagination">
    <div class="relative flex-1 min-h-64">
      <div class="h-full absolute w-full">
        <div class="h-full overflow-scroll w-full p-5" ref="messagesContainer">
          <div class="h-full flex flex-col">
            <div class="flex-1" ref="messages">
              <div class="flex justify-center mb-3">
                <button @click="loadMoreMessages()" :disabled="isLoadingMoreMessages" v-if="pagination.current_page !== pagination.last_page" class="text-blue-500 hover:underline font-semibold text-sm">
                  {{ __('Load more messages') }}
                </button>
              </div>
              <div v-for="message in records" :key="message.id" class="flex" :class="{'justify-end': wasWrittenByCurrentMember(message)}">
                <div class="flex items-center mb-5 text-sm w-full sm:w-1/2" :class="{'flex-row-reverse': wasWrittenByCurrentMember(message)}">
                  <img :src="message.author.avatar_url" class="w-10 h-10 rounded-full object-cover" :class="{'ml-4': wasWrittenByCurrentMember(message), 'mr-4': !wasWrittenByCurrentMember(message)}"/>
                  <div class="overflow-hidden bg-gray-200 border rounded-lg inline-block py-3 px-3">
                    <div class="mb-1">
                      <span class="font-bold text-xs">{{ message.author.name }}</span>
                      <span class="text-grey text-xs">{{ message.created_at }}</span>
                    </div>
                    <p class="text-black leading-normal">{{ message.body }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full p-5 bg-gray-200 border-t">
      <div class="relative">
        <textarea ref="chatTextArea" class="textarea-input block text-base resize-none" :class="{'error': error('body') }" v-model="form.body" @keyup.enter.exact="submitMessage" :placeholder="__('Type message...')"></textarea>

        <loading-button :loading="isSendingMessage" class="inline-block absolute right-0 bottom-0 bg-coral-400 hover:opacity-75 px-2 sm:px-6 py-2 h-full rounded-r text-white font-semibold" @click="submitMessage">
          {{ __('Send') }}
        </loading-button>
      </div>
      <div v-if="error('body')" class="text-red-500 text-sm mt-2">{{ error('body') }}</div>
    </div>
  </div>
</template>

<script>
import TextareaInput from '@/Shared/TextareaInput';
import LoadingButton from '@/Shared/LoadingButton';

export default {
  props: {
    job: Object,
    messages: Object,
    conversation: Object,
  },
  components: {
    TextareaInput,
    LoadingButton,
  },
  data() {
    return {
      form: {
        body: '',
      },
      records: [],
      pagination: {},
      isLoadingMoreMessages: false,
      isSendingMessage: false,
    };
  },

  created() {
    this.scrollToNewMessage();
    setTimeout(() => {
      this.scrollToNewMessage();
    }, 300);
  },

  mounted() {
    this.pagination = this.messages.meta;
    this.records = this.messages.data.reverse();
  },

  watch: {
    messages(newMessages, oldMessages) {
      this.records = newMessages.data.reverse();
    },
  },

  methods: {
    wasWrittenByCurrentMember(message) {
      if (!this.$page.props.auth.user && message.author_type === 'App\\Models\\Client') {
        return true;
      }

      if (this.$page.props.auth.user && this.$page.props.auth.user.id === message.author_id && message.author_type === 'App\\Models\\User') {
        return true;
      }

      return false;
    },

    scrollToNewMessage() {
      this.$nextTick(() => {
        this.$refs.messagesContainer.scrollTo(0, this.$refs.messages.clientHeight);
      });
    },

    loadMoreMessages() {
      this.isLoadingMoreMessages = true;
      window.axios.get(this.route('conversationMessages.index', {conversation: this.conversation.id, page: this.pagination.current_page + 1}))
          .then(({data}) => {
            this.records = data.data.reverse().concat(this.records);
            this.pagination = data.pagination;

            this.$nextTick(() => {
              this.$refs.messagesContainer.scrollTo(0, 0);
            });
          }).finally(() => this.isLoadingMoreMessages = false);
    },

    submitMessage() {
      this.isSendingMessage = true;

      let data = {
        ...this.form,
        deviceClientId: sessionStorage.getItem('deviceClientId'),
      };

      this.$inertia.post(this.route('conversationMessages.store', {conversation: this.conversation.id}), data, {
        preserveScroll: true,
        preserveState: false,
      }).finally(() => {
        this.isSendingMessage = false;
      });

      this.form.body = null;
    },
  },
};
</script>
